export default __webpack_public_path__ + "static/media/sample-bg.54f787b9.png";